var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickValidation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "valid-cross",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    className: "sub-path-icon",
    transform: "translate(-625.000000, -625.000000)",
    fill: "#26C957"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6590803,6.8640394 C15.4015298,7.10238233 15.141019,7.34346483 14.8834685,7.58180776 C13.7526146,8.62832498 12.6247211,9.67210263 11.4938672,10.7186199 C10.7833831,11.373378 10.0758593,12.0308757 9.36833558,12.6856339 C8.91540195,13.1047887 8.14571083,13.1047887 7.69277721,12.6856339 C7.55364073,12.5568739 7.41450426,12.428114 7.27832814,12.299354 C6.29845213,11.3898155 5.31857612,10.4830165 4.33870012,9.57347797 C3.87096474,9.1406253 3.9035286,8.46121098 4.33870012,8.02287915 C4.77091129,7.58728691 5.57612662,7.61742222 6.01425849,8.02287915 C6.15339496,8.15163913 6.29253143,8.2803991 6.42870755,8.40915907 C7.13031062,9.05843808 7.83191368,9.71045666 8.53055639,10.3597357 C9.64068782,9.33239547 10.7478589,8.30779484 11.8579903,7.28045463 L13.983522,5.31344059 C14.4512573,4.88058792 15.1854243,4.91072323 15.6590803,5.31344059 C16.1297761,5.71615795 16.0972122,6.45858247 15.6590803,6.8640394 Z",
    id: "Path"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickValidation);
export default __webpack_public_path__ + "static/media/tick-validation.ac506895dd3bdc0bcfc923790f41fa88.svg";
export { ForwardRef as ReactComponent };